import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = { class: "fw-bolder text-muted" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-250px" }, "Skill", -1)
const _hoisted_5 = { class: "min-w-150px" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Base rate", -1)
const _hoisted_8 = { class: "min-w-150px" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Level bonus", -1)
const _hoisted_11 = { class: "min-w-150px" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Weekend bonus", -1)
const _hoisted_14 = { class: "min-w-150px" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Night bonus", -1)
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "d-flex justify-content-end" }
const _hoisted_19 = {
  key: 0,
  class: "min-w-150px text-end"
}
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "fs-5 fw-bold" }
const _hoisted_22 = ["value", "onChange"]
const _hoisted_23 = ["value", "onChange"]
const _hoisted_24 = ["value", "onChange"]
const _hoisted_25 = ["value", "onChange"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "text-end"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomizeRateModal = _resolveComponent("CustomizeRateModal")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_CustomizeRateModal, {
      key: _ctx.key,
      onSuccess: _ctx.handleSuccessfulSave,
      onSaveData: _cache[0] || (_cache[0] = data => _ctx.$emit('saveRatesModal', data)),
      branchID: _ctx.branchID,
      skillID: _ctx.selectedSkillID,
      ref: "customizeRatesModal"
    }, null, 8, ["onSuccess", "branchID", "skillID"])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("th", null, [
              _createVNode(_component_el_checkbox, {
                style: {"padding":"0 8px"},
                onChange: _cache[1] || (_cache[1] = event => _ctx.handleSelectAllRows(event))
              })
            ]),
            _hoisted_4,
            _createElementVNode("th", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control w-100 w-xl-75 w-xxl-50",
                    style: {"height":"32px"},
                    id: "maskedInput",
                    onChange: _cache[2] || (_cache[2] = event => (_ctx.bulkEdit.base_rate = event.target.value))
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control w-100 w-xl-75 w-xxl-50",
                    style: {"height":"32px"},
                    id: "maskedInput",
                    onChange: _cache[3] || (_cache[3] = event => (_ctx.bulkEdit.level_bonus = event.target.value))
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control w-100 w-xl-75 w-xxl-50",
                    style: {"height":"32px"},
                    id: "maskedInput",
                    onChange: _cache[4] || (_cache[4] = 
                    event => (_ctx.bulkEdit.weekend_bonus = event.target.value)
                  )
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control w-100 w-xl-75 w-xxl-50",
                    style: {"height":"32px"},
                    id: "maskedInput",
                    onChange: _cache[5] || (_cache[5] = event => (_ctx.bulkEdit.night_bonus = event.target.value))
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  style: {"height":"28px"},
                  class: "d-flex align-items-center btn btn-sm btn-primary",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyBulkEdit && _ctx.applyBulkEdit(...args)))
                }, " Apply ")
              ])
            ]),
            (!_ctx.isModal)
              ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Actions"))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(), _createElementBlock("tbody", { key: _ctx.tableKey }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSkills, (skill) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: skill.id
            }, [
              _createElementVNode("td", _hoisted_20, [
                _createVNode(_component_el_checkbox, {
                  style: {"padding":"0 8px"},
                  onChange: ($event: any) => (_ctx.handleSelect(skill.id)),
                  checked: _ctx.bulkEditList.includes(skill.id)
                }, null, 8, ["onChange", "checked"])
              ]),
              _createElementVNode("td", _hoisted_21, _toDisplayString(skill.name), 1),
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  class: "form-control w-100 w-xl-75 w-xxl-50",
                  id: "maskedInput",
                  value: _ctx.model[skill.id].base_rate,
                  onChange: 
                event =>
                  _ctx.handleInput({
                    value: event.target.value,
                    id: skill.id,
                    field: 'base_rate'
                  })
              
                }, null, 40, _hoisted_22)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  class: "form-control w-100 w-xl-75 w-xxl-50",
                  id: "maskedInput",
                  value: _ctx.model[skill.id].level_bonus,
                  onChange: 
                event =>
                  _ctx.handleInput({
                    value: event.target.value,
                    id: skill.id,
                    field: 'level_bonus'
                  })
              
                }, null, 40, _hoisted_23)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  class: "form-control w-100 w-xl-75 w-xxl-50",
                  value: _ctx.model[skill.id].weekend_bonus,
                  id: "maskedInput",
                  onChange: 
                event =>
                  _ctx.handleInput({
                    value: event.target.value,
                    id: skill.id,
                    field: 'weekend_bonus'
                  })
              
                }, null, 40, _hoisted_24)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("input", {
                  class: "form-control w-100 w-xl-75 w-xxl-50",
                  id: "maskedInput",
                  value: _ctx.model[skill.id].night_bonus,
                  onChange: 
                event =>
                  _ctx.handleInput({
                    value: event.target.value,
                    id: skill.id,
                    field: 'night_bonus'
                  })
              
                }, null, 40, _hoisted_25)
              ]),
              _hoisted_26,
              (!_ctx.isModal)
                ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      onClick: ($event: any) => (_ctx.openCustomizeModal(skill.id))
                    }, " Customize ", 8, _hoisted_28)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      (!_ctx.isModal)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveRates && _ctx.saveRates(...args))),
            disabled: _ctx.isSavingRate,
            class: "btn btn-success"
          }, [
            (_ctx.isSavingRate)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31))
              : _createCommentVNode("", true),
            _hoisted_32
          ], 8, _hoisted_30))
        : _createCommentVNode("", true)
    ])
  ], 64))
}